import { TopMenu } from '../../components';
export function topMenu(content) {
    return new TopMenu({ content: content });
}
